import {
  TRACK_CLICKED_SHARE_TRACKER,
  TRACK_COPIED_SHARE_TRACKER_LINK,
  TRACK_VIEWED_SHARED_ORDER_PAGE,
} from './types';

export function trackClickedShareTracker() {
  return (dispatch, getState) => {
    const state = getState();

    const orderStatus = state.order.status;
    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Clicked share tracker',
      properties: {
        order_stage: statusMessage,
        order_id: orderId,
      },
    };

    return dispatch({
      type: TRACK_CLICKED_SHARE_TRACKER,
      payload,
    });
  };
}

export function trackCopiedShareTrackerLink() {
  return (dispatch, getState) => {
    const state = getState();

    const orderStatus = state.order.status;
    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Copied share tracker link',
      properties: {
        order_stage: statusMessage,
        order_id: orderId,
      },
    };

    return dispatch({
      type: TRACK_COPIED_SHARE_TRACKER_LINK,
      payload,
    });
  };
}

export function trackViewedSharedOrderPage() {
  return (dispatch, getState) => {
    const state = getState();

    const orderStatus = state.order.status;
    const orderId = orderStatus.order && orderStatus.order.id ? orderStatus.order.id : null;
    const statusMessage =
      orderStatus.attributes && orderStatus.attributes.analytics
        ? orderStatus.attributes.analytics.status_message
        : null;

    const payload = {
      name: 'Viewed shared order page',
      properties: {
        order_stage: statusMessage,
        order_id: orderId,
      },
    };

    return dispatch({
      type: TRACK_VIEWED_SHARED_ORDER_PAGE,
      payload,
    });
  };
}
